import { createFieldSelectorHook } from 'src/lib/sweetState';

import { ProjectStore } from './ProjectStore';

export const useProjectProcessingIds = createFieldSelectorHook(ProjectStore, 'processingIds');
